import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=038512ab&scoped=true"
var script = {}
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=038512ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038512ab",
  null
  
)

export default component.exports